import angular from 'angular';
import '../../shared.module';
import template from './pagination.component.html';
import './pagination.component.scss';
import { PAGE_SIZE_OPTIONS } from '../../services/paginated-list.service';

class PaginationController {
  constructor() {
    this.pageSizeOptions = PAGE_SIZE_OPTIONS.map((value) => ({
      value,
      label: `${value} por página`
    }));
  }

  get totalPages() {
    const size = this.pageSize || PAGE_SIZE_OPTIONS[1];
    return Math.max(1, Math.ceil((this.total || 0) / size));
  }

  get rangeLabel() {
    const total = this.total || 0;
    if (!total) return '0 de 0';
    const start = (this.page - 1) * this.pageSize + 1;
    const end = Math.min(total, this.page * this.pageSize);
    return `${start}–${end} de ${total}`;
  }

  get canGoBack() {
    return !this.loading && this.page > 1;
  }

  get canGoForward() {
    return !this.loading && this.page < this.totalPages;
  }

  goTo(page) {
    if (this.loading || page < 1 || page > this.totalPages || page === this.page) return;
    if (this.onPageChange) this.onPageChange({ page });
  }

  changePageSize() {
    if (this.onPageSizeChange) this.onPageSizeChange({ pageSize: Number(this.selectedPageSize) });
  }

  $onChanges(changes) {
    if (changes.pageSize) this.selectedPageSize = this.pageSize;
  }
}

angular.module('app.shared').component('cpPagination', {
  bindings: {
    page: '<',
    pageSize: '<',
    total: '<',
    loading: '<',
    onPageChange: '&',
    onPageSizeChange: '&'
  },
  controller: PaginationController,
  controllerAs: 'vm',
  template
});
